import { Controller } from "@hotwired/stimulus"

// MaggiorazioneCopertura di pages/VerificaBandi.js: la casella mostra o nasconde i campi; la prima attivazione di una
// maggiorazione che non c'era parte dai valori predefiniti ({ tipo, percentuale: 90, eta_massima_anni: 35,
// titolo_massimo_anni: 6, estero_minimo_anni: 3 }). Il campo `_presente` lo abilita dati_passo_controller#tocca (dopo).
const PREDEFINITI = { percentuale: 90, eta_massima_anni: 35, titolo_massimo_anni: 6, estero_minimo_anni: 3 }

export default class extends Controller {
  static targets = ["presente", "tipo", "attiva", "numero", "dettaglio"]

  attiva() {
    if (this.attivaTarget.checked && this.presenteTarget.disabled) {
      this.tipoTarget.value = "compagine_integrale_o_esperto"
      this.numeroTargets.forEach((n) => { n.value = String(PREDEFINITI[n.dataset.chiave]) })
    }
    this.dettaglioTargets.forEach((el) => { el.hidden = !this.attivaTarget.checked })
  }
}
